// Validations importées (décision D3/D5 de la tâche P11) : un chargement de carte pivot garde la validation présente
// dans le fichier mais la marque `provenance.extensions.ekera_import`. L'application ne la présente jamais comme une
// validation faite dans Ekera : pas de nom de validateur, pas de « Décidée le » sans la mention « importée ».
import { dateFr } from './format';

interface AvecExtensions {
  extensions?: { [cle: string]: unknown } | null;
}

export interface ImportMarque {
  le: string | null;
  format: string | null;
}

/** Le marqueur du chargement, ou null si la provenance n'a pas été importée. */
export function importMarque(p: AvecExtensions | null | undefined): ImportMarque | null {
  const m = p?.extensions?.ekera_import;
  if (!m || typeof m !== 'object') return null;
  const o = m as Record<string, unknown>;
  return { le: typeof o.le === 'string' ? o.le : null, format: typeof o.format === 'string' ? o.format : null };
}

/** « validation importée le 21/10/2026 (chargement par l'opérateur) » ; jamais le nom de `valide_par`. */
export function texteValidationImportee(m: ImportMarque): string {
  return `validation importée${m.le ? ` le ${dateFr(m.le)}` : ''} (chargement par l’opérateur)`;
}

/** Même idée pour une date de décision : « Décidée le … (importée) » si la fiche vient d'un chargement. */
export function decideLe(date: string | null | undefined, p: AvecExtensions | null | undefined): string {
  if (!date) return dateFr(date);
  return importMarque(p) ? `${dateFr(date)} (importée)` : dateFr(date);
}
